import { Component, OnInit } from '@angular/core';
import { ExternalUserService } from '@externaluserservice/external-user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionHistory, TransactionHistoryUpdate } from '@externalusermodel/Order';
import { Location } from '@angular/common';
import { ChaseUIDRequest } from '@externalusermodel/AdvancePayment';
import { ChaseProfileTransactionData } from '@externalusermodel/ChaseProfileTransactionData';


@Component({
    selector: 'app-order-invoice-details',
    templateUrl: './order-invoice-details.component.html',
    styleUrls: ['./order-invoice-details.component.css'],
    providers: [ExternalUserService],
    standalone: false
})
export class OrderInvoiceDetailsComponent implements OnInit {

  Ordertotalamount: number;
  selectedOrderIDs: string;
  OderagencyName: string;

  isPayment: boolean;
  orderDetail: any = [];
  actualAmount: number;
  InvalidAmount: boolean;
  InvalidAmount2: boolean;
  OrderagencyID: string;
  isSelectedMultipleOrderInvoice: boolean;
  isChecked: boolean;
   ProfileDetail: any = [];
   Records = [];
   count:any;
  paymenttype:string;

  displayAddRefundPopUp: boolean;
  UserID: any;
  profile: any = [];
  response_data: string;
  methodName: string;

  chaseOrderId: string;
  private sub: any;


  AmountpayingACH: string;
  AmountpayingCC: string;

  uIDRequestData: ChaseUIDRequest;

  isCreateNewProfileDisabled: boolean;
  isProfileSubmitDisabled: boolean;

  selectedProfile: any;

  profileTransType: string;

  orderInvoiceCount: number;
ShowACH: boolean = false;
  ShowCC: boolean = false;

  //Ajay - Button Disable
  isLoading: boolean = true;

  history: TransactionHistory[];

  selectedPayType: boolean;

  constructor(private externalUserService: ExternalUserService, private route: ActivatedRoute,
    private _location: Location, private router: Router) {
    this.Ordertotalamount = 0;
    this.selectedOrderIDs = '';
    this.isPayment = true;
    this.displayAddRefundPopUp = false;
    this.ShowACH = false;
    this.ShowCC = false;
  }

  ngOnInit() {

this.ShowACH = true;
    this.ShowCC = false;
    this.OrderagencyID = sessionStorage.getItem('AgencyID');

    this.sub = this.route.params.subscribe(params => {
       this.chaseOrderId = params['chaseOrderId']; 
      
       this.externalUserService.getTransactionHistory(this.chaseOrderId)
            .subscribe(
              (p) => {
                //let history: TransactionHistory[];
                this.history = p;
                this.orderInvoiceCount =  this.history.length;
            for (let hist of this.history) {
              this.Ordertotalamount += hist.totalAmount;
              this.selectedOrderIDs = this.selectedOrderIDs + hist.invoiceId + ', ';
            }

          this.actualAmount = this.Ordertotalamount;
          this.selectedOrderIDs = this.selectedOrderIDs.substr(0, this.selectedOrderIDs.length - 2);
          this.OderagencyName = this.history[0].agencyId.toString();
          // this.paymenttype = "Full";

          // to load page after user comes back from payment page
          if (this.history[0].isPartialPayment == true && this.history[0].transactionAmount != null) {
            // debugger;
            this.paymenttype = "Partial";
            this.Ordertotalamount = this.history[0].partialAmount;
            this.isChecked = false;
            this.isPayment = false;
          }
          else {
            this.paymenttype = "Full";
            this.isChecked = true;
            this.isPayment = true;
          }

          // ends here

          this.externalUserService.GetInvoiceDetail(this.Ordertotalamount, this.OrderagencyID, this.paymenttype, this.chaseOrderId, this.history).subscribe(
            (q) => {
              //Ajay - Button Disable
              this.isLoading = false;

              this.orderDetail = q;
              this.AmountpayingACH = q['invTotalNetDiscountACH'].toString().replace(/,/g, '');
              this.AmountpayingCC = q['invTotalNetDiscountCC'].toString().replace(/,/g, '');

            }
          );
          if (this.orderInvoiceCount > 1) {
            this.isSelectedMultipleOrderInvoice = true;
          } else {
            this.isSelectedMultipleOrderInvoice = false;
          }
        }
        );

    });






    this.InvalidAmount = false;
    this.InvalidAmount2 = false;
    this.isChecked = true;
    // if (this.selectedOrderIDs.includes(",")) {
    //   this.isSelectedMultipleOrder = true;
    // }
    // else {
    //   this.isSelectedMultipleOrder = false;
    // }

    this.UserID = sessionStorage.getItem('userid');

  }

  reCalculate(event, OrderagencyID,paymenttype) {

   
    this.InvalidAmount = false;
    this.InvalidAmount2 = false;


    if (Number(this.Ordertotalamount) >= this.actualAmount && this.isChecked === false) {
      this.InvalidAmount = true;
    } else if (Number(this.Ordertotalamount) <= 0) {
      this.InvalidAmount2 = true;
    } else {
      //Ajay - Button Disable
      this.isLoading = true;

      this.externalUserService.GetInvoiceDetail(this.Ordertotalamount, this.OrderagencyID,this.paymenttype, this.chaseOrderId, this.history).subscribe(
        p => {
          //Ajay - Button Disable
          this.isLoading = false;
          
          this.orderDetail = p;
           this.AmountpayingACH =  p['invTotalNetDiscountACH'].toString().replace(/,/g, '');       
           this.AmountpayingCC =  p['invTotalNetDiscountCC'].toString().replace(/,/g, '');    
          
        },
      );
    }
  }

  onChecked(event) {

    if (event.target.checked === false) {
      this.isChecked = false;
      this.isPayment = false;
      this.InvalidAmount = false;
      this.paymenttype ="Partial";
    } else {
      this.isChecked = true;
      this.isPayment = true;
      this.Ordertotalamount = this.actualAmount;
      this.paymenttype ="Full";
      //this.Ordertotalamount = parseFloat((sessionStorage.getItem("OrderTotalAmount").toString().replace(/,/g, '')));
      this.OrderagencyID = sessionStorage.getItem('AgencyID');
      this.reCalculate(this.Ordertotalamount, this.OrderagencyID,this.paymenttype);
      if (this.actualAmount >= +this.Ordertotalamount) {
        this.InvalidAmount = false;
      }
    }
  }
  //Method to go back
  goback() {
    sessionStorage.removeItem('profileTransType');
    this.router.navigate(['Invoice', 'order']);
  }

  Paynowprofile(value: any) {

    let requestData = new TransactionHistoryUpdate();
    requestData.chaseOrderId = this.chaseOrderId;
    //   for caputring ACH and CC net amount
   requestData.ordTotalNetDiscountACH = this.AmountpayingACH;
   requestData.ordTotalNetDiscountCC = this.AmountpayingCC;


    if (this.paymenttype === "Partial") {
      requestData.isPartialPayment = true;
      requestData.partialAmount = this.Ordertotalamount.toString();
    }
    else
      requestData.isPartialPayment = false;

    if (value === 1) {
      this.profileTransType = 'ACH';
      requestData.transactionAmount = this.AmountpayingACH;
    } else if (value === 2) {
      this.profileTransType = 'CC';
      requestData.transactionAmount = this.AmountpayingCC;
    }

    this.externalUserService.updateTransactionHistory(requestData).subscribe(
      response => {
        let status = response;

        if (status === 'Success') {
          this.router.navigate(['MediaPayPayment', 'OrderInvoice', this.profileTransType, this.chaseOrderId]);
        }
      });

  }
  onRadioACHChecked(event) {


    if (event.target.checked == true) {
      this.ShowACH = true;
      this.ShowCC = false;
    }
  }
  onRadioCCChecked(event) {
    //debugger;
    if (event.target.checked == true) {
      this.ShowCC = true;
      this.ShowACH = false;
    }
  }
}
